import { moneyValidator } from "@/utils/validate";

export default {
    computed: {
        detailRule() {
            return {
                count: [
                    { required: true, message: "请填写数量", trigger: "change" },
                    {
                        validator: function (rule, value, callback) {
                            const r=/^\d+$/g;
                            if (!r.test(value)) {
                                callback(new Error("请输入正确的数量"));
                            }
                            callback();
                        },
                        trigger: "change",
                    },
                ],
            }
        },
        
    }
}